import { MenuItem, styled } from "~/common/mui";

export const QuickActionMenuItem = styled(MenuItem)(({ theme }) => ({
  minWidth: 300,
  padding: 0,
  "& .scha__link": {
    color: `${theme.palette.text.primary} !important`,
    padding: `${theme.spacing(1)} ${theme.spacing(3)} ${theme.spacing(1)} ${theme.spacing(2)} !important`,
    gap: theme.spacing(1),
    width: "100%",
  },
}));
